import ResizeScale from '@/lib/resize-scale.js'

export default {
    methods: {
        toggleFullScreen: function () {
            this.fullscreen.toggle({
                type: this.backgroundType,
                image: this.backgroundImage,
                color: this.backgroundColor
            })

            this.checkingFullScreen()
        },

        resizeScaleQuizFrame() {
            const contentElem = document.getElementsByClassName('content-container')[0]
            const layoutElem = document.getElementsByClassName('layout')[0]
            const headerElem = document.getElementsByClassName('header')[0]
            const footerElem = document.getElementsByClassName('footer')[0]
            const footerHeight = footerElem.getBoundingClientRect().height
            const headerHeight = headerElem.getBoundingClientRect().height
            const uselessHeight = headerHeight + footerHeight

            contentElem.style.transform = 'none'
            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            new ResizeScale({
                width: contentElem.getBoundingClientRect().width,
                height: contentElem.getBoundingClientRect().height,
                child: contentElem,
                parent: layoutElem,
                uselessHeight: uselessHeight,
                noTransForm: false
            })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')

            if (this.isAlreadyShow != null && typeof this.isAlreadyShow != 'undefined') {
                this.isAlreadyShow = true
            }
        },

        checkFullscreen() {
            const self = this

            self.isFullscreen =
                document.documentElement.clientWidth == screen.width &&
                document.documentElement.clientHeight == screen.height

            document.onfullscreenchange = function () {
                setTimeout(() => {
                    self.isFullscreen =
                        document.documentElement.clientWidth == screen.width &&
                        document.documentElement.clientHeight == screen.height
                }, 10)
            }
        },

        checkingFullScreen() {
            this.isFullscreen = this.fullscreen.checkFullScreen()
        }
    },
}